/* @jsx m */
import m from 'mithril';

import Icon from './Icon.jsx';

export default function AppHeader() {
  return {
    view: (vnode) => {
      return (
          <div className="row status-bar">
            <div className="col s6 left-align">
              <span>{vnode.attrs.time || '00:00'}</span>
            </div>
            <div className="col s6 right-align">
              <Icon name="signal"></Icon>
              <Icon name="battery-full"></Icon>
            </div>
          </div>
      );
    },
  }
}
